import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { View } from 'modules/shift_management/lib/types'

import { daysOrHoursCopy, rowsSelectedCopy } from './utils'

export interface SelectionProps {
  allTableSelected: boolean
  rowsSelectedCount: number
  daysSelectedCount: number
  cellCount: number
  view: View
}

const SelectionIndicator = ({
  allTableSelected,
  rowsSelectedCount,
  daysSelectedCount,
  cellCount,
  view,
}: SelectionProps) => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s4">
      {rowsSelectedCount > 0 && (
        <Text.Normal size="100" weight="medium">
          - {rowsSelectedCopy(view, rowsSelectedCount)}
        </Text.Normal>
      )}
      {!allTableSelected && daysSelectedCount > 0 && (
        <Text.Normal size="100" weight="medium">
          {daysOrHoursCopy(view, daysSelectedCount)}
        </Text.Normal>
      )}
      {!view.isDaily && cellCount > 0 && (
        <Text.Normal size="100" weight="medium">
          {i18n.tp('shift_management.cells_selected', {
            count: cellCount,
          })}
        </Text.Normal>
      )}
      {rowsSelectedCount > 0 && (
        <Text.Normal size="100" weight="medium">
          {i18n.t('common.selected')}.
        </Text.Normal>
      )}
    </Box>
  )
}

export default SelectionIndicator
